module.exports = __webpack_public_path__ + "ee3753ff6e126446478d275a30f6fd28.svg";